// TypeScript 3.7 ships no type for ResizeObserver
declare class ResizeObserver {
	constructor(callback: () => void);
	observe(target: Element): void;
	disconnect(): void;
}

declare global {
	interface Window {
		mpdHeaderHeightWatched?: boolean;
	}
}

let published = '';

function publishHeaderHeight() {
	const header = document.querySelector<HTMLElement>('.header-container');
	if (!header) return;
	const height = `${header.offsetHeight}px`;
	if (height === published) return;
	published = height;
	document.documentElement.style.setProperty('--header-height', height);
	// jQuery resize handlers that size from offsets recompute
	$(window).trigger('resize');
}

$(() => {
	// Every bundle carries a copy of this module; one publisher per page is enough
	if (window.mpdHeaderHeightWatched) return;
	const header = document.querySelector('.header-container');
	if (!header) return;
	window.mpdHeaderHeightWatched = true;

	// Older browsers (iOS 12 and earlier) have no ResizeObserver; a throw here would stop every later ready handler
	if (typeof ResizeObserver === 'undefined') {
		publishHeaderHeight();
		$(window).on('resize.header-height load.header-height', publishHeaderHeight);
		$(document).one('logout', () => $(window).off('.header-height'));
		return;
	}

	// Counters and late fonts can make the bar wrap without the window changing size
	const observer = new ResizeObserver(publishHeaderHeight);
	observer.observe(header);
	$(document).one('logout', () => observer.disconnect());
});

export {};
